/* © CNES */
/**
 * Possible authentication resolution step enumeration
 */
export const AuthenticationResolution = {
  notAuthenticated: 'notAuthenticated',
  authenticated: 'authenticated',
} as const;
